import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import ReportingService from "Lib/API/reporting";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const EventsWidget = ({ customizeMode, onRemove }) => {
  const history = useHistory();
  const fetcher = useCallback((token) => ReportingService.getWidgetEvents(token), []);
  const { data, loading, error, retry } = useWidgetData(fetcher);

  const items = data?.events || [];

  const goToEvent = (ev) => {
    if (customizeMode || !ev._id) return;
    history.push(`/event-participants/details/${ev._id}`);
  };

  return (
    <WidgetWrapper
      title="Upcoming Events"
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
    >
      {items.length === 0 ? (
        <div className="list-widget__empty">No upcoming events</div>
      ) : (
        <div className="widget-scroll-list" style={{ maxHeight: 400 }}>
          {items.slice(0, 5).map((ev, i) => {
            const d = new Date(ev.date);
            const mon = MONTHS[d.getMonth()];
            const day = d.getDate();
            const cap = ev.capacity || 0;
            const reg = ev.registrations || 0;
            const isFull = cap > 0 && reg >= cap;
            const clickable = !customizeMode && !!ev._id;
            return (
              <div
                key={ev._id || i}
                className={`event-row${clickable ? " event-row--clickable" : ""}`}
                onClick={() => goToEvent(ev)}
              >
                <div className="event-date">
                  <div className="event-date__month">{mon}</div>
                  <div className="event-date__day">{day}</div>
                </div>
                <div className="event-info">
                  <div className="event-info__name">{ev.title}</div>
                </div>
                <div className="event-cap">
                  <div className={`event-cap__reg${isFull ? " event-cap__reg--full" : ""}`}>
                    {reg}{cap > 0 ? `/${cap}` : ""}
                  </div>
                  <div className="event-cap__sub">registered</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </WidgetWrapper>
  );
};

export default EventsWidget;
